export default [
	'.bj.cn',
	'.sh.cn',
	'.tj.cn',
	'.cq.cn',
	'.he.cn',
	'.sx.cn',
	'.nm.cn',
	'.ln.cn',
	'.jl.cn',
	'.hl.cn',
	'.js.cn',
	'.zj.cn',
	'.ah.cn',
	'.fj.cn',
	'.jx.cn',
	'.sd.cn',
	'.ha.cn',
	'.hb.cn',
	'.hn.cn',
	'.gd.cn',
	'.gx.cn',
	'.hi.cn',
	'.sc.cn',
	'.gz.cn',
	'.yn.cn',
	'.xz.cn',
	'.sn.cn',
	'.gs.cn',
	'.qh.cn',
	'.nx.cn',
	'.xj.cn',
	'.tw.cn',
]



// WEBPACK FOOTER //
// ./static/assets/suffix3.js